import { User } from '../../../types/user';

interface ProfileHeaderProps {
  user: User | null;
}

/**
 * ProfileHeader - Cabeçalho do perfil do usuário
 *
 * Exibe avatar, nome e email
 * Migrado para Tailwind CSS v4
 */
export const ProfileHeader = ({ user }: ProfileHeaderProps) => {
  if (!user) return null;

  // Get initial for avatar
  const initial = user.name.charAt(0).toUpperCase();

  return (
    <div
      className="rounded-2xl p-6 mb-8"
      style={{
        background: 'linear-gradient(135deg, rgba(244, 196, 4, 0.1) 0%, transparent 50%)'
      }}
    >
      <div className="flex items-center gap-6">
        {/* Avatar */}
        <div className="w-24 h-24 rounded-2xl bg-[#1a1a1a] flex items-center justify-center flex-shrink-0">
          <span className="text-5xl font-bold text-[#F4CC04]">
            {initial}
          </span>
        </div>

        {/* User Info */}
        <div className="flex flex-col gap-2">
          {/* Name */}
          <div className="text-4xl font-bold text-white leading-none m-0">
            {user.name}
          </div>

          {/* Email */}
          <a
            href={`mailto:${user.email}`}
            className="text-lg text-[#F4CC04] hover:text-[#f5d633] transition-colors leading-none no-underline font-medium"
          >
            {user.email}
          </a>
        </div>
      </div>
    </div>
  );
};
